import Vue from "vue";
import Router from "vue-router";

import { Ability } from "@casl/ability";
import { store, The_Ability } from "../store/index";
import swal from "@/plugins/sweet-alert2";
import Api from "../api/index";

import actionPlanRoutes from "@/_action-plan/routes";
import authRoutes from "@/_auth/authRoutes";

import notificationRoutes from "@/_notifications/notificationRoutes";

import executionRoutes from "@/_execution/executionRoutes";

import retailDashboardRoutes from "@/_reports/retail/retailDashboardRoutes";

import importExecutionRoutes from "@/_import_execution/importExecutionRoutes";

import customFieldRoutes from "@/_custom_fields/customFieldRoutes";

import TasksRoutes from "@/_tasks/tasksRoutes";

import ExtraInfoRoutes from "@/_extra_info/ExtraInfoRoutes";
import LaudoRoutes from "@/_laudos/LaudoRoutes";
import GhostRoutes from "../_ghost_execution/GhostRoutes";

import FlowRoutes from "../_flow/FlowRoutes";
import admClientRouter from "../_adm/clients/admClientRouter";

import approvalRoutes from "../_approvals/routes";

import AiAnalysisRoutes from "../_ai_analysis/routes";
import AiExtractRoutes from "../_ai_extract/routes";


//Views
// const v_ai_analysis_page = () => import("@/views/ai_analysis/GenerateAnalysisWithAi.vue");

const v_home_page = () => import("@/views/HomePage");
const v_profile = () => import("@/views/Profile");
const v_forms = () => import("@/views/FormList");
const v_done_forms = () => import("@/views/FormDone");
const v_dashboard = () => import("@/views/Dashboard");
const v_form_dashboard = () => import("@/views/FormDashboard");
const v_analytics = () => import("@/views/Analytics");
const v_feedback = () => import("@/views/Feedback");
const v_settings = () => import("@/views/Settings");
const v_about = () => import("@/views/About");
const v_activity = () => import("@/views/Activity");
const v_scout = () => import("@/views/Scout");
const v_company_register = () => import("@/views/MyCompany");
const v_admin = () => import("@/views/AdminCkb");
const v_billing = () => import("@/views/Billing");

const v_data_export = () => import("@/views/data_exports/DataExport");
const v_data_import = () => import("@/views/data_imports/DataImport");
const v_auth_callback = () => import("@/views/AuthCallback");

//Child
const c_resove_monthly_form = () =>
  import("@/components/reports/show/resolve/MonthlyForm");
const c_combat_monthly_form = () =>
  import("@/components/reports/show/combat/MonthlyCombat");
const c_one_done_form = () => import("@/components/forms/show/OneDoneForm");
const c_department_employees = () =>
  import("@/components/company/registers/DepartmentEmployees");
const c_department_forms = () =>
  import("@/components/company/registers/DepartmentForms");

function hasRequirePermission(to, from, next) {
  return new Promise((resolve) => {
    console.log("VERIFICANDO...");
    if (The_Ability.can(to.meta.permission.act, to.meta.permission.on)) {
      console.log("Rota permitida");
      resolve(true);
    } else {
      if (store.state.User.oneUser == null) {
        console.log("Rota não permitida");
        resolve(false);
      } else {
        resolve(false);
      }
    }
  });
}

function alertUnpermitted() {
  Vue.prototype.$sweetAlerts.toast1(
    "info",
    "Você não tem permissão para acessar\r\nRedirecionado para o início.",
    5000
  );
}

Vue.use(Router);
// Create a new router
const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    ...authRoutes,
    ...actionPlanRoutes,
    ...executionRoutes,
    ...notificationRoutes,

    ...admClientRouter,

    // ...importExecutionRoutes,


    ...customFieldRoutes,
    ...TasksRoutes,

    ...ExtraInfoRoutes,
    ...LaudoRoutes,
    ...GhostRoutes,
    ...FlowRoutes,

    ...approvalRoutes,

    ...AiAnalysisRoutes,

    ...AiExtractRoutes,
    {
      path: "/",
      name: "Homepage",
      meta: {
        auth: true,
        translated: "Início",
        permission: { act: "read", on: "Dashboard" },
      },
      component: v_home_page,
      // beforeEnter: checkToken,
    },

    {
      path: "/data_export",
      name: "DataExport",
      meta: {
        auth: true,
        translated: "Exportações",
        permission: { act: "read", on: "DoneForm" },
      },
      component: v_data_export,
    },
    {
      path: "/data_import",
      name: "DataImport",
      meta: {
        auth: true,
        translated: "Importações",
        permission: { act: "create", on: "Form" },
      },
      component: v_data_import,
    },
    {
      path: "/billing",
      name: "Billing",
      meta: {
        // auth: true,
        translated: "Faturas",
        permission: { act: "create", on: "Bill" },
      },
      component: v_billing,
    },
    {
      path: "/admin_ckb",
      name: "Admin",
      meta: {
        auth: true,
        translated: "Administração",
        permission: { act: "manage", on: "Checkbits" },
      },
      component: v_admin,
      beforeEnter(to, from, next) {
        hasRequirePermission(to).then((has) => {
          if (has) {
            next();
          } else {
            setTimeout(() => {
              alertUnpermitted();
              console.log("Usuário não permitido redirecionado!");
              next("/");
            }, 500);
          }
        });
      },
    },

    {
      path: "/company/register",
      name: "MyCompany",
      meta: {
        auth: true,
        translated: "Minha Empresa",
        permission: { act: "read", on: "Department" },
      },
      component: v_company_register,
      children: [
        // {
        //   path: "department_details/:id",
        //   meta: {
        //     auth: true,
        //     translated: "Minha Empresa",
        //     permission: { act: "create", on: "Department" },
        //   },
        //   name: "DepartmentDetails",
        //   component: () => import("@/components/company/DepartmentDetails.vue"),
        //   children: [
        //     {
        //       path: "forms",
        //       name: "DepartmentForm",
        //       meta: {
        //         auth: true,
        //         translated: "Minha Empresa",
        //         permission: { act: "create", on: "Department" },
        //       },
        //       component: () =>
        //         import("@/components/forms/listing/FormList.vue"),
        //     },
        //     {
        //       path: "employees",
        //       name: "DepartmentEmployee",
        //       meta: {
        //         auth: true,
        //         translated: "Minha Empresa",
        //         permission: { act: "create", on: "Department" },
        //       },
        //       component: () =>
        //         import("@/components/registers/DepartmentEmployee.vue"),
        //     },
        //   ],
        //   //   path:'department_employees/:id',
        //   //   name: 'DepartmentEmployees',
        //   //   component: c_department_employees
        //   // },
        //   // {
        //   //   path:'department_forms/:id',
        //   //   name: 'DepartmentForms',
        //   //   component: c_department_forms
        //   // }
        //   // ]
        // },
      ],
    },
    {
      path: "/forms",
      name: "Forms",
      meta: {
        auth: true,
        translated: "Formulários",
        permission: { act: "create", on: "DoneForm" },
      },
      component: v_forms,
      // beforeEnter: checkToken,
    },
    {
      path: "/forms/edit/:id",
      name: "EditForm",
      meta: {
        auth: true,
        translated: "Formulários",
        permission: { act: "update", on: "Form" },
      },
      component: () => import("@/views/EditForm.vue"),
    },
    {
      path: "/forms/new",
      name: "NewForms",
      meta: {
        auth: true,
        translated: "Novo Formulário",
        permission: { act: "create", on: "Form" },
      },
      component: () => import("@/views/CreateForm.vue"),
    },
    {
      path: "/forms/new_with_ai",
      name: "NewFormWithAi",
      meta: {
        auth: true,
        translated: "Novo Formulário Com IA",
        permission: { act: "create", on: "Form" },
      },
      component: () => import("@/views/CreateFormWithAi.vue"),
    },
    {
      path: "/done_forms",
      name: "DoneForms",
      meta: {
        auth: true,
        translated: "Enviados",
        permission: { act: "read", on: "DoneForm" },
      },
      component: v_done_forms,
      // beforeEnter: checkToken,
    },
    {
      path: "/done_forms/:id",
      name: "OneDoneForm",
      meta: {
        auth: true,
        translated: "Enviado",
        permission: { act: "read", on: "DoneForm" },
      },
      component: c_one_done_form,
    },
    {
      path: "/done_forms/:id/print",
      name: "PrintOneDoneForm",
      meta: {
        auth: true,
        translated: "Enviado",
        permission: { act: "read", on: "DoneForm" },
      },
      component: () => import('../views/PrintOneDoneForm.vue'),
    },
    {
      path: "/activity",
      name: "Atividade",
      meta: {
        auth: true,
        translated: "Minha Atividade",
        permission: { act: "create", on: "DoneForm" }, //must have other stuff about activities
      },
      component: v_activity,
      // children: [
      //   {
      //     path: 'pending',
      //     name: 'ActivityPending',
      //     meta:{
      //       auth: true,
      //       translated: 'Minha Atividade',
      //       permission: {act: 'create', on: 'DoneForm'} //must have other stuff about activities
      //     },
      //     component: () => import('../components/activity/PendingPost.vue'),
      //   },
      //   {
      //     path: 'partial',
      //     name: 'ActivityPartial',
      //     meta:{
      //       auth: true,
      //       translated: 'Minha Atividade',
      //       permission: {act: 'create', on: 'DoneForm'} //must have other stuff about activities
      //     },
      //     component: () => import('../components/activity/PendingConclusion.vue'),
      //   },
      // ]
    },
    {
      path: "/scout",
      name: "Observador",
      meta: {
        auth: true,
        translated: "Observador",
        permission: { act: "create", on: "Scout" }, //must have other stuff about scouts
      },
      component: v_scout,
    },
    {
      path: "/action_plans_dashboard",
      name: "ActionPlansDashboard",
      meta:{
        auth: true,
        translated: "Dashboard de planos de ação",
        permission: { act: "create", on: "DoneForm" },
      },
      component: () => import("../_reports/retail/components/index/action_plan/ActionPlanDashboard.vue"),
    },
    {
      path: "/dashboard",
      name: "Dashboard",
      meta: {
        auth: true,
        translated: "Dashboard",
        permission: { act: "read", on: "Dashboard" },
      },
      component: v_dashboard,
      children: [
        ...retailDashboardRoutes,

        {
          path: "resolve/:id",
          name: "MonthlyForm",
          meta: {
            auth: true,
            translated: 'Dashboard',
            permission: {act: 'read', on: 'Dashboard'} 
          },
          component: c_resove_monthly_form,
        },
        {
          path: "covid/:id",
          name: "MonthlyCombat",
          meta: {
            auth: true,
            translated: 'Dashboard',
            permission: {act: 'read', on: 'Dashboard'} 
          },
          component: c_combat_monthly_form,
        },
      ],
    },

    {
      path: "/dashboard/:id",
      name: "FormDashboard",
      meta: {
        auth: true,
        translated: "Dashboard",
        permission: { act: "read", on: "Dashboard" },
      },
      component: v_form_dashboard,
    },
    {
      path: "/profile",
      name: "Perfil",
      meta: {
        auth: true,
        translated: "Meu Perfil",
        permission: { act: "read", on: "User" },
      },
      component: v_profile,
    },
    // {
    //   path: '/settings',
    //   name: 'Gerenciar',
    //   meta:{
    //     auth: true,
    //     translated: 'Gerenciamento',
    //   },
    //   component: v_settings,
    // },
    {
      path: "/feedback",
      name: "Feedback",
      meta: {
        auth: true,
        translated: "Fale Conosco",
        permission: { act: "read", on: "Dashboard" },
      },
      component: v_feedback,
    },
    {
      path: "/unpermitted",
      name: "Unpermitted",
      meta: {
        auth: true,
      },
      component: () => import("@/views/Unpermitted.vue"),
    },
    {
      path: "/auth_callback",
      name: "AuthCallback",
      component: v_auth_callback,
    },
    // {
    //   path: '/about',
    //   name: 'Sistema',
    //   meta:{
    //     auth: true,
    //     translated: 'Definições do Sistema',
    //   },
    //   component: v_about,
    // },

    // {
    //   path: '/analytics',
    //   name: 'Análise',
    //   meta:{
    //     auth: true,
    //     translated: 'Solução Customizada',
    //   },
    //   component: v_analytics,
    // },

    // {
    //   path: '/registrar',
    //   name: 'Registrar',
    //   component: 'Registrar'
    // },
    // {
    //   path: '/perfil',
    //   name: 'Perfil',
    //   component: 'UserProfile',
    //   meta: {
    // auth: true,
    //   }

    // }
    {
      path: '*',
      name: 'Err404',
      component: () => import('@/views/Err404.vue'),
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  },
});

// NAO ROLA BEM CHECANDO TODAS. FAZER O CHECK NA DIRECTIVA BEFOREENTER NA ROTA ESPECIFICA

// router.beforeEach((to, from, next) => {
//   if (store.state.User.oneUser) {
//     if (!["/login", "/logout", "/password", "/recover"].includes(to.path)) {
//       console.log("BeforeEach vai checar meta permission");
//       console.log("Usuario abaixo ja esta definido...");
//       hasRequirePermission(to).then((has) => {
//         // console.log(has);
//         if (has) {
//           next();
//         } else {
//           setTimeout(() => {
//             console.log("Usuário não permitido redirecionado!");
//             next("/unpermitted");
//           }, 500);
//         }
//       });
//     } else {
//       next();
//     }
//   } else {
//     next();
//   }
// });

Vue.router = router;

export default router;
